/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import DTOPaySlip from "./DTOPaySlipModal";
import PaySlipModalPresenter from "./PaySlipModalPresenter";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  payslipData?: any;
}

interface empDetails {
  name: string;
  desig: string;
  empId: number;
  staffId: number;
  currency: string;
}

const PaySlipModalController = ({
  isModalOpen,
  closeModal,
  payslipData,
}: ModalInterface) => {
  const [empDetails, setEmpDetails] = useState<empDetails>({
    name: "",
    desig: "",
    empId: 0,
    staffId: 0,
    currency: "",
  });

  const getEmpDetails = (data: any) => {
    setEmpDetails({
      name: data.empName,
      desig: data.empDesig,
      empId: data.employeeId,
      staffId: data.staff_id,
      currency: data.currency,
    });
  };

  return (
    <>
      <DTOPaySlip setEmpDetails={getEmpDetails} />

      <PaySlipModalPresenter
        closeModal={closeModal}
        isModalOpen={isModalOpen}
        employeeDesignation={empDetails.desig}
        employeeId={empDetails.empId}
        staffId={empDetails.staffId}
        employeeName={empDetails.name}
        currency={empDetails.currency}
        payslipData={payslipData}
      />
    </>
  );
};

export default PaySlipModalController;
